<div class="main-logout-container delete-ui" *ngIf="value=='deleteAccount'">
    <h2 class="delete-header">Delete Account?</h2>
    <hr>
    <p *ngIf="gracePeriod == false && subscriptionExpired == false && isTrialPeriod == false && subEndDate != null" class="logout-subtitle">Choose how you'd like to proceed:</p>
    <p *ngIf="gracePeriod == true || subscriptionExpired == true || subEndDate == null || isTrialPeriod == true" class="logout-subtitle-single">Are you sure want to delete your account now!</p>
    <div class="delete-options" *ngIf="gracePeriod == false && subscriptionExpired == false && isTrialPeriod == false  &&  subEndDate != null">
        <mat-radio-group [(ngModel)]="deleteOption" (change)="radioSelected($event)">
            <mat-radio-button class="radio-option" value="immediate">
                <strong>Delete Account Immediately</strong>
                <div class="option-desc">Permanently delete your account and data immediately.</div>
            </mat-radio-button>
            <mat-radio-button class="radio-option" value="30days">
                <strong>Delete Account After Subscription Ends</strong>
                <div class="option-desc">Your account and data will be deleted once your subscription ends.</div>
            </mat-radio-button>
        </mat-radio-group>
    </div>

    <div class="logout-button-div">
        <button class="logout-cancel-button equal-width-button" mat-flat-button color="accent"
            (click)="close()">Cancel</button>
        <button mat-flat-button class="logout-button equal-width-button" color="warn" (click)="confirmDelete()">Confirm</button>
    </div>
</div>
<div *ngIf="value ==='confirmDelete'" class="second-confirmation-box">
    <div *ngIf="deleteOption === 'immediate'">
        <h3>Are you sure you want to delete your account immediately?</h3>
        <hr>
        <p>
            If you proceed, your account and all your data will be permanently deleted immediately.
        </p>
        <p>This action cannot be undone or restored.</p>

        <div class="confirm-buttons">
            <button class="logout-cancel-button equal-width-button" mat-flat-button color="accent" (click)="close()"
                (click)="showConfirm = false">Cancel</button>
            <button mat-flat-button class="logout-button equal-width-button" color="warn" (click)="delete()">Yes, Delete</button>
        </div>
    </div>

    <!-- For Scheduled Deletion -->
    <div *ngIf="deleteOption === '30days'">
        <h3>Are you sure you want to schedule your account for deletion?</h3>
        <hr>
        <p>
            If you proceed, your account and all your data will be automatically deleted after your current subscription
            ends.
        </p>
        <p>This action cannot be undone or restored.</p>
        <div class="confirm-buttons">
            <button class="logout-cancel-button equal-width-button" mat-flat-button color="accent" (click)="close()"
                (click)="showConfirm = false">Cancel</button>
            <button mat-flat-button class="logout-button equal-width-button" color="warn" (click)="delete()">Yes, Delete</button>
        </div>
    </div>
</div>